import { render, staticRenderFns } from "./EnterPhone.vue?vue&type=template&id=39065f17&"
import script from "./EnterPhone.vue?vue&type=script&lang=js&"
export * from "./EnterPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports